import React from 'react';
import './contactusd.css'

const Contactusd = (props) => {
    return ( <>
    <div className='contactusd'>
        <img className='iconsizee' src={props.ppp} alt="" />
        <h2 className='infooo'>{props.infooo}</h2>
    </div>
    </> );
}
 
export default Contactusd;